import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  REQUEST_MESSAGE_COUNT,
  REQUEST_MESSAGE_COUNT_SUCCESS,
  REQUEST_MESSAGE_COUNT_ERROR,
} from '../constants/MessageConstants';
import { CHANGE_EVENT } from '../constants/AppConstants';
import { getMessageCount } from '../utils/MessageApiUtils';

let messageCount = 0;

class MessageStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getMessageCount() {
    return messageCount;
  }

  dispatcherCallback(data) {
    switch (data.action.actionType) {
      case REQUEST_MESSAGE_COUNT:
        getMessageCount();
        break;

      case REQUEST_MESSAGE_COUNT_SUCCESS:
        messageCount = data.action.data;
        this.emitChange();
        break;

      case REQUEST_MESSAGE_COUNT_ERROR:
        messageCount = 0;
        this.emitChange();
        break;

      default: {
        break;
      }
    }
  }
}

export default new MessageStore();
